import { Action } from "@/api-schema-enums";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { ContactBlacklistForm } from "../_components/contact-blacklist-form";

export function CasaviContactBlacklistCreateView() {
  const { t } = useTranslation(["casavi"]);
  const pageTitle = t("casavi:CreateNewBlacklistEntry");
  const pageSubtitle = t("casavi:AddANewEntryToTheCasaviContactBlacklist");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ContactBlacklistForm mode={Action.Create} />
    </CenteredLayout>
  );
}
